<template>
  <div class="filters-container">
    <el-row :gutter="16">
      <el-col :span="2">
        <div class="custom-label">Fecha desde</div>
        <el-date-picker
          v-model="filters.FechaDesde"
          type="date"
          size="default"
          placeholder="Seleccione una fecha"
          format="DD/MM/YYYY"
          style="width: auto"
          clearable
        />
      </el-col>
      <el-col :span="2">
        <div class="custom-label">Fecha hasta</div>
        <el-date-picker
          v-model="filters.FechaHasta"
          type="date"
          size="default"
          placeholder="Seleccione una fecha"
          format="DD/MM/YYYY"
          style="width: auto"
          clearable
        />
      </el-col>
      <custom-select
        v-model="filters.Estado"
        label="Estado"
        :spanColumn="3"
        :settings="{
          placeholder: 'Seleccionar estado',
          options: orderImportStateList,
          clearable: true,
        }"
      />
      <custom-input
        v-model="filters.Cliente"
        label="Cliente"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar cliente',
        }"
      />
      <custom-input
        v-model="filters.CodigoProductoPedido"
        label="Código producto"
        :spanColumn="3"
        :settings="{
          placeholder: 'Ingresar código producto',
        }"
      />
      <custom-input
        v-model="filters.DescripcionProducto"
        label="Producto"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar producto',
        }"
      />
    </el-row>

    <el-row
      :gutter="24"
      class="margin-row"
    >
      <custom-input
        v-model="filters.TipoProducto"
        label="Tipo de producto"
        :spanColumn="3"
        :settings="{
          placeholder: 'Ingresar tipo de producto',
        }"
      />

      <custom-input
        v-model="filters.Vendedor"
        label="Vendedor"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar vendedor',
        }"
      />
      <custom-input
        v-model="filters.OrdenCompra"
        label="Orden de compra"
        :spanColumn="4"
        :settings="{
          placeholder: 'Ingresar orden de compra',
        }"
      />
      <custom-input
        v-model="filters.CodigoPedido"
        label="Código pedido"
        :spanColumn="3"
        :settings="{
          placeholder: 'Ingresar código pedido',
        }"
      />
      <el-col
        :span="4"
        class="button-container"
      >
        <el-button
          type="primary"
          size="default"
          @click="filtrar"
          >Filtrar</el-button
        >
        <el-popover
          placement="right"
          :width="40"
          effect="dark"
          trigger="hover"
          content="Limpiar filtros"
        >
          <template #reference>
            <el-button
              type="danger"
              size="default"
              :icon="IconDelete"
              @click="LimpiarFiltros"
            ></el-button>
          </template>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import { useOrderImportStore } from '../stores/order_import_store.js';
import IconDelete from '~icons/mdi/delete';

const orderImportStore = useOrderImportStore();
const { filters } = storeToRefs(orderImportStore);
const { findAllOrderImportHTTP, setPage, emptyList, resetFilter } = orderImportStore;

const orderImportStateList = [
  { Descripcion: 'Pendiente', Codigo: 1 },
  { Descripcion: 'Completo', Codigo: 2 },
  { Descripcion: 'Anulado', Codigo: 3 },
  { Descripcion: 'Todos', Codigo: null },
];

const filtrar = () => {
  try {
    emptyList();
    setPage(1);
    findAllOrderImportHTTP();
  } catch (error) {
    console.error('Error al filtrar pedidos:', error);
  }
};

const LimpiarFiltros = () => {
  resetFilter();
  filtrar();
};
</script>

<style scoped>
.filters-container {
  background-color: white;
  border: 3px solid lightgray;
  padding: 20px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.button-container {
  margin-top: auto;
}

.margin-row {
  margin-top: 1%;
}

.date-picker {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}
</style>
